import { BadgeCheck } from "lucide-react";

/**
 * Badge « Organisateur certifié ».
 * variants: "inline" (icône + texte), "icon" (icône seule), "pill" (pastille).
 */
export default function VerifiedBadge({ verified, variant = "inline", size = 15, className = "", testId = "verified-badge" }) {
  if (!verified) return null;

  if (variant === "icon") {
    return (
      <BadgeCheck
        size={size}
        className={className}
        color="var(--z-teal)"
        aria-label="Organisateur certifié"
        data-testid={testId}
        style={{ flexShrink: 0 }}
      />
    );
  }

  if (variant === "pill") {
    return (
      <span
        data-testid={testId}
        className={className}
        style={{
          display: "inline-flex", alignItems: "center", gap: 4,
          background: "rgba(1,105,111,0.12)", color: "var(--z-teal)",
          padding: "2px 8px", borderRadius: 999, fontSize: 11.5, fontWeight: 700,
          whiteSpace: "nowrap",
        }}
        title="Organisateur certifié par Zevents"
      >
        <BadgeCheck size={13} /> Certifié
      </span>
    );
  }

  return (
    <span
      data-testid={testId}
      className={className}
      title="Organisateur certifié par Zevents"
      style={{ display: "inline-flex", alignItems: "center", gap: 4, color: "var(--z-teal)", fontWeight: 600, fontSize: 13 }}
    >
      <BadgeCheck size={size} /> Certifié
    </span>
  );
}
